import { createContext, ReactNode, useContext } from "react";
import { PlosTranslations } from "./types";
import { defaultTranslations } from "./defaultTranslations";

const PlosTranslationsContext =
  createContext<PlosTranslations>(defaultTranslations);

export const usePlosTranslations = () => useContext(PlosTranslationsContext);

export const PlosTranslationsProvider = ({
  translations,
  children,
}: {
  translations: PlosTranslations;
  children: ReactNode;
}) => {
  return (
    <PlosTranslationsContext.Provider value={translations}>
      {children}
    </PlosTranslationsContext.Provider>
  );
};
